"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var classnames_1 = __importDefault(require("classnames"));
var Checkbox_1 = __importDefault(require("../Checkbox"));
var Typography_1 = __importDefault(require("../Typography"));
var MenuItem_1 = __importDefault(require("../MenuItem"));
var Grid_1 = __importDefault(require("../Grid"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        menuItem: {
            padding: 0,
            minHeight: 0
        },
        checkboxContainer: {
            paddingLeft: "".concat(spacing(1.5), "px !important")
        },
        checkbox: {
            marginLeft: 'auto',
            marginRight: 'auto'
        },
        txt: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        },
        labelContainer: {
            minWidth: 0
        }
    });
});
var MultiSelectMenuItem = function (_a) {
    var _b, _c, _d, _e, _f;
    var item = _a.item, onClick = _a.onClick, _g = _a.selected, selected = _g === void 0 ? false : _g, style = _a.style, showCheckbox = _a.showCheckbox, _h = _a.classes, classes = _h === void 0 ? {} : _h;
    var internalClasses = useStyles();
    if (!item)
        return null;
    return (react_1.default.createElement(MenuItem_1.default, { classes: { root: (0, classnames_1.default)(internalClasses.menuItem, ((_b = classes === null || classes === void 0 ? void 0 : classes.menuItem) === null || _b === void 0 ? void 0 : _b.root) || '') }, onClick: onClick, style: style, selected: selected },
        react_1.default.createElement(Grid_1.default, { container: true, alignItems: "center", wrap: "nowrap" },
            showCheckbox && (react_1.default.createElement(Grid_1.default, { item: true, classes: {
                    item: (0, classnames_1.default)(internalClasses.checkboxContainer, ((_c = classes === null || classes === void 0 ? void 0 : classes.menuItem) === null || _c === void 0 ? void 0 : _c.checkboxContainer) || '')
                } },
                react_1.default.createElement(Checkbox_1.default, { isChecked: selected, color: "primary", inputProps: { onClick: onClick }, classes: { formControlLabel: { root: internalClasses.checkbox } } }))),
            react_1.default.createElement(Grid_1.default, { item: true, classes: { item: internalClasses.labelContainer } }, (typeof item === 'object' && ('value' in item)) ? (react_1.default.createElement(Typography_1.default, { variant: "body2", classes: __assign(__assign({}, (((_d = classes === null || classes === void 0 ? void 0 : classes.menuItem) === null || _d === void 0 ? void 0 : _d.text) || {})), { root: (0, classnames_1.default)(internalClasses.txt, ((_f = (_e = classes === null || classes === void 0 ? void 0 : classes.menuItem) === null || _e === void 0 ? void 0 : _e.text) === null || _f === void 0 ? void 0 : _f.root) || '') }) },
                react_1.default.createElement("span", { title: item.value }, item.value))) : item))));
};
exports.default = MultiSelectMenuItem;
